/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IConceptTerms {
  id?: string;
  cui?: string | null;
  lat?: string | null;
  sab?: string | null;
  tty?: string | null;
  str?: string | null;
  code?: string | null;
  sty?: string | null;
}

export const defaultValue: Readonly<IConceptTerms> = {};
